//action types
export const SHOW_JASA = "SHOW_JASA";
export const SHOW_TESTING_FORM = "SHOW_TESTING_FORM";
export const TOGGLE_NAVIGATE = "TOGGLE_NAVIGATE";

//action creator functions
export const showJasaTogle = (showState) => ({type: SHOW_JASA, id: showState});
export const showTestingForm = (showState) => ({type: SHOW_TESTING_FORM, id: showState});
export const navigateTogle = (showState) => ({type: TOGGLE_NAVIGATE, id: showState});